import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft, Info } from 'lucide-react';

const About = () => (
  <div className="min-h-screen bg-background flex flex-col" data-testid="about-page">
    <header className="px-5 py-4">
      <Link to="/" className="inline-flex items-center gap-2 text-slate-600 hover:text-slate-900">
        <ArrowLeft className="h-4 w-4" />
        <span className="text-sm font-medium">Back to home</span>
      </Link>
    </header>
    <main className="flex-1 px-5 pb-10">
      <div className="max-w-md mx-auto text-center pt-6">
        <div className="mx-auto w-14 h-14 bg-amber-100 rounded-2xl flex items-center justify-center mb-5">
          <Info className="h-7 w-7 text-amber-600" />
        </div>
        <h1 className="text-2xl sm:text-3xl font-heading font-extrabold text-slate-900">
          About Sturent
        </h1>
        <p className="mt-3 text-base text-slate-600 leading-relaxed">
          Coming soon. We're putting together our story — who we are, why we built Sturent,
          and how we keep listings honest.
        </p>
        <Link to="/">
          <Button className="btn-primary mt-7 px-7 py-5 text-base">Back home</Button>
        </Link>
      </div>
    </main>
  </div>
);

export default About;
